import { auctionStatuses } from 'constants/publishedProduct'
import { useAuction } from 'hooks/data/auction/useAuction'
import { useAuctionProduct } from 'hooks/data/auction/useAuctionProduct'
import { useGetTranslated } from 'hooks/useGetTranslated'
import { useAppTranslation } from 'i18n/hooks'
import { Redirect, useParams } from 'react-router'
import styled from 'styled-components'
import { Breadcrumb } from '../../../components/Breadcrumb'
import { Item } from './Item'
import { SimilarProducts } from './SimilarProducts'

export const Product = () => {
  const { t } = useAppTranslation()
  const { auctionId, productId } = useParams()
  const { product, loading } = useAuctionProduct(auctionId, productId)
  const { auction } = useAuction(auctionId)
  const getTranslated = useGetTranslated()

  if (product?.auctionStatus === auctionStatuses.DISABLED) return <Redirect to={`/auction/${auctionId}`} />

  if (!loading && !product?.id) return <Redirect to="/not-found" />

  return (
    <>
      <StyledBreadcrumb
        links={[
          { link: '/', label: t('home') },
          { link: `/auction/${auctionId}`, label: auction?.auctionId },
          { link: `/auction/${auctionId}/${productId}`, label: getTranslated(product?.name) },
        ]}
      />
      <Item product={product} auction={auction} loading={loading} />
      {product?.category && <SimilarProducts categoryId={product.category.id} />}
    </>
  )
}

const StyledBreadcrumb = styled(Breadcrumb)`
  padding: 0 1rem;
  margin-bottom: 2rem;
`
